export const getFontsTemplate = (t: (key: string) => string) => [
  {
    title: t("fontsTemplate.rootTitle"),
    subTitle: t("fontsTemplate.rootSubtitle"),
    keyFamily: "tint-font-root",
    keyStyle: "tint-font-root-style",
    keyWeight: "tint-font-root-weight",
  },
  {
    title: t("fontsTemplate.h1Title"),
    subTitle: t("fontsTemplate.h1Subtitle"),
    keyFamily: "tint-font-h1",
    keyStyle: "tint-font-h1-style",
    keyWeight: "tint-font-h1-weight",
  },
  {
    title: t("fontsTemplate.h2Title"),
    subTitle: t("fontsTemplate.h2Subtitle"),
    keyFamily: "tint-font-h2",
    keyStyle: "tint-font-h2-style",
    keyWeight: "tint-font-h2-weight",
  },
  {
    title: t("fontsTemplate.h3Title"),
    subTitle: t("fontsTemplate.h3Subtitle"),
    keyFamily: "tint-font-h3",
    keyStyle: "tint-font-h3-style",
    keyWeight: "tint-font-h3-weight",
  },
  {
    title: t("fontsTemplate.h4Title"),
    subTitle: t("fontsTemplate.h4Subtitle"),
    keyFamily: "tint-font-h4",
    keyStyle: "tint-font-h4-style",
    keyWeight: "tint-font-h4-weight",
  },
  // {
  //   title: "H5",
  //   subTitle: "Small titles",
  //   keyFamily: "tint-font-h5",
  //   keyStyle: "tint-font-h5-style",
  //   keyWeight: "tint-font-h5-weight",
  // },
  // {
  //   title: "H6",
  //   subTitle: "Small titles",
  //   keyFamily: "tint-font-h6",
  //   keyStyle: "tint-font-h6-style",
  //   keyWeight: "tint-font-h6-weight",
  // },
  {
    title: t("fontsTemplate.buttonTitle"),
    subTitle: t("fontsTemplate.buttonSubtitle"),
    keyFamily: "tint-font-button",
    keyStyle: "tint-font-button-style",
    keyWeight: "tint-font-button-weight",
  },
]
